/**
 * TagListContainer
 * --
 */

import { useEffect, useState } from 'react';
import TagListPresenter from './TagListPresenter';
import { TagApi } from 'api';
import { useGetTags } from 'hooks/TagHooks';

const TagListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const response = useGetTags();
  const [ tagList, setTagList ] = useState([]);
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  const handleGetTagList = async () => {
    const response = await TagApi.getTags();

    if (response.status === 200 && Array.isArray(response.data)) {
      setTagList(response.data);
    }
  }

  /* ===== HOOKS ===== */
  useEffect(() => {
    if (response && response.data) {
      const { data } = response.data;
      setTagList(data);
    }
  }, [response])
  /* ===== RENDER ===== */
  return (
    <>
      <TagListPresenter tagList={tagList} />
    </>
  );
};

export default TagListContainer;
